import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

type ProctorManagementNavigationTabItem = NavigationTabItem & {
  requiredPermission: string[];
};

const TAB_ITEMS: ProctorManagementNavigationTabItem[] = [
  {
    value: 'Proctor List',
    label: 'ผู้คุมสอบทั้งหมด',
    path: '/:examCenterCode/exam-proctors/proctors',
    requiredPermission: [APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR.VIEW],
  },
  {
    value: 'Proctor Requests',
    label: 'รายการยื่นคำขออนุมัติผู้คุมสอบ',
    path: '/:examCenterCode/exam-proctors/requests',
    requiredPermission: [APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW],
  },
];

export default function ProctorManagementNavigationTabs() {
  const { permissions } = usePermission();

  const filteredItems = useMemo(
    () =>
      TAB_ITEMS.filter((tabItem) =>
        tabItem.requiredPermission.every((permission) => permissions.includes(permission)),
      ),
    [permissions],
  );

  return <NavigationTabs items={filteredItems} />;
}
